<template>
  <div class="profile-details-wrapper">
    <span class="profile-details-title">Preset details</span>

    <div class="profile-details">
      <div class="profile-details-content">
        <ThemedColumnText
          class="font-weight-light"
          topText="Name"
          :bottomText="selectedProfile.profileName"
        />
        <ThemedColumnText
          class="font-weight-light"
          topText="Wind direction"
          :bottomText="selectedProfile.windDirection"
        />
        <ThemedColumnText
          class="font-weight-light"
          topText="LHV (kJ/kg)"
          :bottomText="displayNumericValue(selectedProfile.lhv, 1)"
        />
        <ThemedColumnText
          class="font-weight-light"
          topText="Mean draft (m)"
          :bottomText="displayNumericValue(selectedProfile.draft, 2)"
        />
        <ThemedColumnText
          class="font-weight-light"
          topText="Trim (m)"
          :bottomText="displayNumericValue(selectedProfile.trim, 3)"
        />
        <ThemedColumnText
          class="font-weight-light"
          topText="True wind (bft)"
          :bottomText="displayNumericValue(selectedProfile.trueWind, 1)"
        />
        <ThemedColumnText
          class="font-weight-light text-wrap"
          topText="STW (kn)"
          :bottomText="selectedProfile.valuesList"
          style="white-space: normal; word-wrap: break-word"
        />
        <ThemedColumnText
          class="font-weight-light text-wrap"
          topText="Fouling"
          :bottomText="displayNumericValue(selectedProfile.fouling, 1)"
          style="white-space: normal; word-wrap: break-word"
        />
        <ThemedColumnText
          class="font-weight-light text-wrap"
          topText="Date range"
          :bottomText="
            displayDate(selectedProfile.minDate, selectedProfile.maxDate)
          "
          style="white-space: normal; word-wrap: break-word"
        />
      </div>

      <div class="profile-details-actions">
        <PresetEditingEditView />
        <PresetEditingAddView />
        <DeletePresetDialog />
      </div>
    </div>
  </div>
</template>

<script>
import ThemedColumnText from "../../../../core/ThemedColumnText.vue";
import PresetEditingEditView from "../EditView.vue";
import PresetEditingAddView from "../AddView.vue";
import DeletePresetDialog from "./DeletePresetDialog.vue";
import { mapState } from "vuex";
import { formatDateString } from "../../../../helper_functions/date_time_formats";
export default {
  name: "ProfileDetails",
  components: {
    ThemedColumnText,
    PresetEditingEditView,
    PresetEditingAddView,
    DeletePresetDialog,
  },
  computed: {
    ...mapState("kDiagram/profiles", ["selectedProfile"]),
  },
  methods: {
    displayNumericValue(value, precision) {
      try {
        return value.toFixed(precision);
      } catch (error) {
        return "-";
      }
    },
    displayDate(minDate, maxDate) {
      if (!minDate || !maxDate){
        return "-";
      }
      return `${formatDateString(minDate)} - ${formatDateString(maxDate)}`;
    },
  },
};
</script>

<style scoped>
.profile-details-wrapper {
  position: relative;
  background-color: var(--color-bg);
}

.profile-details-title {
  color: var(--color-text);
  margin-bottom: 10px;
  display: block;
}

.profile-details {
  position: relative;
  border-radius: 10px;
  border: 1px solid var(--color-secondary-light);
  overflow: visible;
}

.profile-details-content {
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 10px;
}

.profile-details-actions {
  position: absolute;
  top: -15px;
  right: 10px;
  display: flex;
  gap: 8px;
  background-color: var(--color-bg);
  padding: 0 8px;
  z-index: 1;
}

/* Ensure the buttons are properly styled */
.profile-details-actions :deep(.v-btn) {
  margin: 0;
}
</style>
